import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { FieldTypeEnum } from '@app/core/enums/field-type-enum';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { ValidatorType } from '@app/core/enums/validator-type.enum';
import { FieldValidator } from '@app/core/model/other/field-validator';
import { AbstractFieldBuilder, FieldStateMode } from '@app/shared/components/fields/abstract.field';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'list-field-builder',
    templateUrl: './list-field-builder.component.html',
    styleUrls: ['./list-field-builder.component.scss'],
    standalone: false
})
export class ListFieldBuilderComponent extends AbstractFieldBuilder<FormControl> implements OnInit, AfterViewInit {
  public Permission = PermissionEnum;
  //Display undefined option if the field is not required
  public optional: boolean;

  public options = [];

  constructor() {
    super();
    this.optional = !this.fieldConfig.field.validators.find((validator) => validator.type == ValidatorType.REQUIRED);
    this.options = this.fieldConfig.field.fieldValues;
  }

  public ngOnInit(): void {
    this.form = new FormGroup({
      field: new FormControl(this.fieldInitValue, this.computeValidators())
    });
    this.form.updateValueAndValidity({ emitEvent: false });
    // Initialise the field in the registry
    this.setFieldValue(this.fieldInitValue);
    this.setFieldInitialValue(this.fieldInitValue);
    this.getNextState();
  }

  public ngAfterViewInit(): void {
    this.setupHooks();

    this.form.controls.field.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.setFieldValue(value);
      });

    this.getFieldGroupState()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((newMode) => {
        if (newMode === FieldStateMode.AFTER_SAVE) {
          this.form.controls.field.setValue(this.getFieldValue());
        }
      });
  }

  public cancel(): void {
    this.form.controls.field.setValue(this.getFieldInitialValue());
    super.cancel();
  }

  protected calcFieldInitValue(): void {
    if (this.fieldConfig.field.fieldType === FieldTypeEnum.NUMERIC_LIST) {
      this.fieldConfig.field.fieldValues = this.fieldConfig.field.fieldValues.map((value) => +value);
    }
    super.calcFieldInitValue();
  }

  protected computeValidators(): ValidatorFn {
    const notInArrayValidator = this.validationService.getValidator(
      <FieldValidator>{
        type: ValidatorType.NOT_IN_ARRAY,
        definition: this.fieldConfig.field?.fieldValues
      },
      this.entity
    );
    return Validators.compose([super.computeValidators(), notInArrayValidator]);
  }
}
